import { ActionTypes } from 'Actions/actions';
import { TPromotionTypes } from 'Reducers/promo';

export const setPromoDetails = (
	promoDetails: Partial<Record<TPromotionTypes, any>>,
) => ({
	type: ActionTypes.SET_PROMO_DETAILS,
	payload: promoDetails,
});
